// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> cheyenne-creek
// Generated: 2026-11-02T18:10:51.124Z
// Counts: 0 design, 39 content, 26 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Modern two-bedroom homes with space to thrive</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Walk to Creek Walk and beyond</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Ivy Wild vibes in Colorado Springs</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into Cheyenne Creek and discover everyday ease in Colorado Springs, CO. Your apartment features a cozy fireplace, in-home washer and dryer, granite countertops, and walk-in closets for comfort and style. Step outside for a swim in the indoor pool or relax in the spa. Grill in the picnic area, work out at the fitness center, or unwind in the lounge and courtyard. Life here is designed for effortless Colorado living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about life at Cheyenne Creek? Reach out to our leasing team based in Colorado Springs, CO. We're here to help you learn more, schedule a tour, and find your next home in our connected community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect fit at Cheyenne Creek, with beautifully designed two-bedroom floor plans in Colorado Springs, CO. Each layout features granite countertops, walk-in closets, and ample space for work-from-home or relaxing evenings. Enjoy in-home washers and dryers, abundant storage, and open living areas that invite you to settle in and make it yours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spacious layouts, natural light, and comfy finishes await</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Cheyenne Creek Apartment Homes through photos showcasing our bright, modern interiors and welcoming community amenities. Picture yourself unwinding by the indoor pool, gathering in spacious living rooms, or stepping onto a private balcony with mountain views. Our gallery makes it easy to imagine your next chapter - choose your ideal space and see what life at Cheyenne Creek could be.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Cozy Colorado Springs living near Bear Creek Park</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover what it's like to call the Ivy Wild neighborhood home at Cheyenne Creek in Colorado Springs, CO. Walk outside to leafy streets that lead you to the Creek Walk, Bear Creek Park, and inviting local spots for a bite or coffee. Hop on I-25 for work, errands, or a night out downtown. Whether you crave paths to wander, places to gather, or quick commutes, Cheyenne Creek sets you up for the lifestyle you want in Ivy Wild.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Just outside your door, Ivy Wild's colorful flavor invites you to explore. Bear Creek Park's leafy paths start minutes away, while local favorites line the streets. Downtown Colorado Springs is a quick drive when you crave art, dining, or nightlife. Return home with ease thanks to nearby I-25, and discover how comfort and connection shape daily living at Cheyenne Creek.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Colorado Springs, CO? Cheyenne Creek brings you comfy, pet-friendly two-bedroom homes in the vibrant Ivy Wild neighborhood. Stroll to Creek Walk, relax by the indoor pool, or lounge in your expansive living room with tall ceilings and an in-home washer and dryer. All-in pricing means you know exactly what you're paying - no surprises. Enjoy life with free on-site parking, easy access to I-25, and the welcoming energy only found at Cheyenne Creek.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see Cheyenne Creek Apartment Homes for yourself? Book your tour to get a closer look at our spacious two-bedroom layouts, energy-efficient appliances, and cozy fireplace. Take in our vibrant community amenities, from the indoor pool to the fitness center. Choose the tour style that fits you best, including in-person and virtual options.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual tour of Cheyenne Creek Apartment Homes and explore our layouts, in-home features, and welcoming atmosphere from wherever you are. Discover cozy fireplaces, in-unit washers and dryers, and light-filled living spaces with a click. This easy online walk-through helps you picture everyday moments and plan your move to comfort in Colorado Springs. Prefer an in-person visit? Schedule a tour with our on-site team. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "future-residents-club-hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[5].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[5].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-5dcf-74ce-990b-e3c35c9b7c9c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Indoor swimming pool and jacuzzi area with large windows overlooking trees."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-64df-7427-97a5-b239de04db00.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gym with treadmills, ellipticals, stationary bikes, and free weights."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-723a-75ca-976c-286a00a67b31.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby seating area with fireplace and bar."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-36df-77e5-bce7-8d042c86d45d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with granite countertops, white cabinets, and black refrigerator."
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a17900-7654-755a-bbf9-9959a739eab2.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A dog and cat sitting together on a sunny day, enjoying each other's company."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-3724-777b-8283-8f9dc69ec739.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, armchair, coffee table, and large window."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-78da-71c3-bd54-71f3e540d0e6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby seating area with fireplace and large windows."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-9aa0-72ae-956f-e60d6e5756fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exterior with balconies and surrounding greenery and seating areas."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-432f-7771-8609-fbb82462e893.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with light wood cabinets, white appliances, and a toaster."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-4762-72bb-8e2e-f144142d4fbf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed, nightstands, and a view into a bathroom."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-3724-777b-8283-8f9dc69ec739.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, armchair, coffee table, and large window."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
